import { IControl, clone, EModalType, IValidationConfig, IdHelper, IFieldConfig, IQuickForm } from '../../helpers/';
import { DEFAULT_CONTROL } from '../../constants';
import types from '../types';
import { IDropdownOption } from 'office-ui-fabric-react';

export interface IControlConfigState {
    control: IControl;
    componentId: string;
    controlIndex: number;
    layoutPanelIndex: number;
    fromIndex: number;
    overIndex: number;
    previousOutputBlocks?: any;
    advancedSettingsIndex?: number;
    isRepeatableBlock: boolean;
    validationEditIndex: number;
    editedValidationItem: IValidationConfig;
    caseServiceTypes: IDropdownOption[];
    fieldConfigs?: IFieldConfig[];
    entityViews?: IDropdownOption[];
    entityForms?: IDropdownOption[];
    entityViewColumns?: any[];
    entityFormattedAttributes?: IDropdownOption[];
    quickForms?: IQuickForm[];
    areEntityFormsLoading?: boolean;
    areEntityViewsLoading?: boolean;

}

export const initialState: IControlConfigState = {
    control: clone(DEFAULT_CONTROL),
    componentId: null,
    controlIndex: null,
    layoutPanelIndex: null,
    fromIndex: null,
    overIndex: null,
    previousOutputBlocks: null,
    isRepeatableBlock: false,
    validationEditIndex: null,
    editedValidationItem: null,
    caseServiceTypes: [],
    entityViews: [],
    fieldConfigs: [],
    quickForms: [],
    areEntityFormsLoading: false,
    areEntityViewsLoading: false
};

const controlConfigReducer = function (state: IControlConfigState = initialState, action): IControlConfigState {

    let stateClone: IControlConfigState = clone(state);

    switch (action.type) {

        case types.UPDATE_CONTROL_DIALOG:
            stateClone = updateControl(stateClone, action.control);
            break;

        case types.TOGGLE_DIALOG:
            stateClone = toggleDialog(stateClone, action.openModal, action.control, action.componentId, action.controlIndex, action.previousOutputBlocks, action.isRepeatable, action.layoutPanelIndex);
            break;

        case types.ADD_CONTROL_OPTION:
            stateClone = addOption(stateClone);
            break;

        case types.REMOVE_CONTROL_OPTION:
            stateClone = removeOption(stateClone, action.index);
            break;

        case types.ADD_CONTROL_ITEM:
            stateClone = addItem(stateClone);
            break;

        case types.REMOVE_CONTROL_ITEM:
            stateClone = removeItem(stateClone, action.index);
            break;

        case types.SET_MOVE_FROM_CONTROL_OPTION:
            stateClone = setMoveFromOption(stateClone, action.index);
            break;

        case types.SET_MOVE_OVER_CONTROL_OPTION:
            stateClone = setMoveOverOption(stateClone, action.index);
            break;

        case types.MOVE_CONTROL_OPTION:
            stateClone = moveOption(stateClone, action.toIndex);
            break;

        case types.SET_MOVE_FROM_CONTROL_ITEM:
            stateClone = setMoveFromItem(stateClone, action.index);
            break;

        case types.SET_MOVE_OVER_CONTROL_ITEM:
            stateClone = setMoveOverItem(stateClone, action.index);
            break;

        case types.MOVE_CONTROL_ITEM:
            stateClone = moveItem(stateClone, action.toIndex);
            break;

        case types.UPDATE_CONTROL_OPTION:
            stateClone = updateOption(stateClone, action.index, action.key, action.value);
            break;

        case types.UPDATE_CONTROL_ITEM:
            stateClone = updateItem(stateClone, action.index, action.key, action.value);
            break;

        case types.UPDATE_CONTROL_OUTPUT:
            stateClone = updateOutput(stateClone, action.index, action.name);
            break;

        case types.UPDATE_CONTROL_GLOBAL_OUTPUT:
            stateClone = updateGlobalOutput(stateClone, action.index, action.key);
            break;

        case types.UPDATE_CONTROL_ADVANCED_SETTINGS_INDEX:
            stateClone = updateAdvancedSettingsIndex(stateClone, action.advancedSettingsIndex);
            break;

        case types.UPDATE_CONTROL_OUTPUT_LOGICAL_NAME:
            stateClone = updateControlOutputLogicalName(stateClone, action.index, action.logicalName);
            break;

        case types.UPDATE_CONTROL_OUTPUT_DEFAULT_VALUE:
            stateClone = updateControlOutputDefaultValue(stateClone, action.index, action.defaultValue);
            break;

        case types.SET_VALIDATION_EDIT_INDEX:
            stateClone = setValidationEditIndex(stateClone, action.validationEditIndex);
            break;

        case types.UPDATE_EDITED_VALIDATION_ITEM:
            stateClone = updateEditedValidationItem(stateClone, action.editedValidationItem);
            break;

        case types.SET_CASE_SERVICE_TYPES:
            stateClone = setCaseServiceTypes(stateClone, action.caseServiceTypes);
            break;

        case types.SET_CONTROL_FIELD_FROM_METADATA:
            stateClone = setControlFieldFromMetadata(stateClone, action.fieldConfigs);
            break;

        case types.SET_CONTROL_ENTITY_VIEWS:
            stateClone = setControlEntityViews(stateClone, action.entityViews);
            break;

        case types.SET_CONTROL_ENTITY_FORMS:
            stateClone = setControlEntityForms(stateClone, action.entityForms);
            break;

        case types.SET_CONTROL_ENTITY_VIEW_COLUMNS:
            stateClone = setControlEntityViewColumns(stateClone, action.entityViewColumns);
            break;

        case types.SET_CONTROL_ENTITY_FORMATTED_ATTRIBUTES:
            stateClone = setControlEntityFormattedAttributes(stateClone, action.entityFormattedAttributes);
            break;

        case types.SET_CONTROL_QUICK_FORMS:
            stateClone = setQuickForms(stateClone, action.quickForms);
            break;

        case types.ADD_CONTROL_QUICK_FORM:
            stateClone = addQuickForm(stateClone, action.quickForm);
            break;

        case types.UPDATE_FORM_FIELD_VALUE:
            stateClone = updateFormFieldValue(stateClone, action.formId, action.controlId, action.propertyName, action.value);
            break;

        // case types.SET_CONTROL_FORM_FIELDS:
        //     stateClone = setFormFields(stateClone, action.formFields);
        //     break;

        case types.REMOVE_CONTROL_FIELD_FROM_METADATA:
            stateClone = removeFieldFromMetadata(stateClone);
            break;

        case types.SET_ARE_ENTITY_FORMS_LOADING:
            stateClone = setAreEntityFormsLoading(stateClone, action.value);
            break;

        case types.SET_ARE_ENTITY_VIEWS_LOADING:
            stateClone = setAreEntityViewsLoading(stateClone, action.value);
            break;

        default:
            break;

    }

    return stateClone;

};

let updateControl = (state: IControlConfigState, control: IControl): IControlConfigState => {

    state.control = control ? control : clone(DEFAULT_CONTROL);
    return state;

};

let toggleDialog = (state: IControlConfigState, openModal: EModalType, control: IControl, componentId: string, controlIndex: number, previousOutputBlocks: any, isRepeatableBlock: boolean, layoutPanelIndex?: number): IControlConfigState => {

    if (openModal === EModalType.ControlConfig) {

        if (!control) {
            control = clone(DEFAULT_CONTROL);

            state.control.OutputValues = state.control.OutputValues ? state.control.OutputValues.map(output => {
                output.Id = IdHelper.newGuid();
                return output;
            }) : state.control.OutputValues;
        }

        state.control = control;
        state.componentId = componentId;
        state.controlIndex = controlIndex;
        state.layoutPanelIndex = layoutPanelIndex;
        state.previousOutputBlocks = previousOutputBlocks;
        state.advancedSettingsIndex = null;
        state.isRepeatableBlock = isRepeatableBlock;
    }

    state.editedValidationItem = null;
    state.validationEditIndex = null;

    return state;

};

let addOption = (state: IControlConfigState): IControlConfigState => {

    let newOption = { text: '', key: '' };
    state.control.Properties.filter(prop => prop.Name === 'Value Options')[0].ValueOptions.push(newOption);

    return state;

};

let addItem = (state: IControlConfigState): IControlConfigState => {

    let newItem = { text: '', key: '', url: '', icon: '' };
    state.control.Properties.filter(prop => prop.Name === 'Items')[0].ValueOptions.push(newItem);

    return state;

};

let removeOption = (state: IControlConfigState, index: number): IControlConfigState => {

    state.control.Properties.filter(prop => prop.Name === 'Value Options')[0].ValueOptions.splice(index, 1);
    return state;

};

let removeItem = (state: IControlConfigState, index: number): IControlConfigState => {

    state.control.Properties.filter(prop => prop.Name === 'Items')[0].ValueOptions.splice(index, 1);
    return state;

};

let setMoveFromOption = (state: IControlConfigState, fromIndex: number): IControlConfigState => {

    state.fromIndex = fromIndex;
    return state;

};

let setMoveOverOption = (state: IControlConfigState, index: number): IControlConfigState => {

    state.overIndex = index;
    return state;

};

let moveOption = (state: IControlConfigState, toIndex: number): IControlConfigState => {

    if (toIndex === null) {
        state.fromIndex = null;
        state.overIndex = null;
        return state;
    }

    let options = state.control.Properties.filter(prop => prop.Name === 'Value Options')[0].ValueOptions;
    let option = clone(options[state.fromIndex]);

    options.splice(state.fromIndex, 1);
    options.splice(toIndex, 0, option);

    return state;

};

let setMoveFromItem = (state: IControlConfigState, fromIndex: number): IControlConfigState => {

    state.fromIndex = fromIndex;
    return state;

};

let setMoveOverItem = (state: IControlConfigState, index: number): IControlConfigState => {

    state.overIndex = index;
    return state;

};

let moveItem = (state: IControlConfigState, toIndex: number): IControlConfigState => {

    if (toIndex === null) {
        state.fromIndex = null;
        state.overIndex = null;
        return state;
    }

    let options = state.control.Properties.filter(prop => prop.Name === 'Items')[0].ValueOptions;
    let option = clone(options[state.fromIndex]);

    options.splice(state.fromIndex, 1);
    options.splice(toIndex, 0, option);

    return state;

};

let updateOption = (state: IControlConfigState, index: number, key: string, value: string): IControlConfigState => {

    let option = state.control.Properties.filter(prop => prop.Name === 'Value Options')[0].ValueOptions[index];
    option[key] = value;

    return state;
};

let updateItem = (state: IControlConfigState, index: number, key: string, value: string): IControlConfigState => {

    let option = state.control.Properties.filter(prop => prop.Name === 'Items')[0].ValueOptions[index];
    option[key] = value;

    return state;
};

let updateOutput = (state: IControlConfigState, index: number, name: string): IControlConfigState => {

    let output = state.control.OutputValues[index];
    output.Name = name;

    return state;

};

let updateGlobalOutput = (state: IControlConfigState, index: number, outputId: string): IControlConfigState => {

    let output = state.control.OutputValues[index];
    output.GlobalOutputId = outputId;

    return state;

};

let updateAdvancedSettingsIndex = (state: IControlConfigState, advancedSettingsIndex: number): IControlConfigState => {

    state.advancedSettingsIndex = advancedSettingsIndex;

    return state;

};

let updateControlOutputLogicalName = (state: IControlConfigState, index: number, logicalName: string): IControlConfigState => {

    state.control.OutputValues[index].LogicalName = logicalName;

    return state;

};

let updateControlOutputDefaultValue = (state: IControlConfigState, index: number, defaultValue: string): IControlConfigState => {

    state.control.OutputValues[index].PrepopulatedValue = defaultValue;

    return state;

};

let setValidationEditIndex = (state: IControlConfigState, validationEditIndex: number): IControlConfigState => {

    state.validationEditIndex = validationEditIndex;

    if (validationEditIndex === null) {
        state.editedValidationItem = null;
    }

    return state;
}

let updateEditedValidationItem = (state: IControlConfigState, editedValidationItem: IValidationConfig): IControlConfigState => {

    state.editedValidationItem = editedValidationItem;

    return state;
}

let setCaseServiceTypes = (state: IControlConfigState, caseServiceTypes: IDropdownOption[]): IControlConfigState => {
    state.caseServiceTypes = clone(caseServiceTypes);
    return state;
};

let setControlEntityViews = (state: IControlConfigState, entityViews: IDropdownOption[]): IControlConfigState => {
    state.entityViews = entityViews;
    return state;
};

let setControlFieldFromMetadata = (state: IControlConfigState, fieldConfigs: IFieldConfig[]): IControlConfigState => {
    state.fieldConfigs = fieldConfigs;
    return state;

};
let setControlEntityForms = (state: IControlConfigState, entityForms: IDropdownOption[]): IControlConfigState => {
    state.entityForms = entityForms;
    return state;
};

let setControlEntityViewColumns = (state: IControlConfigState, entityViewColumns: any[]): IControlConfigState => {
    state.entityViewColumns = entityViewColumns;
    return state;
};

let setControlEntityFormattedAttributes = (state: IControlConfigState, entityFormattedAttributes: IDropdownOption[]): IControlConfigState => {
    state.entityFormattedAttributes = entityFormattedAttributes;
    return state;
};

let setQuickForms = (state: IControlConfigState, quickForms: IQuickForm[]): IControlConfigState => {
    state.quickForms = quickForms;
    return state;
};

let addQuickForm = (state: IControlConfigState, quickForm: IQuickForm): IControlConfigState => {
    state.quickForms.push(quickForm);
    return state;
};

let updateFormFieldValue = (state: IControlConfigState, formId: string, controlId: string, propertyName: string, value: string): IControlConfigState => {
    state.quickForms.filter(x => x.formId === formId)[0].layout.forEach(x => {
        let control = [];
        if (propertyName) {
            control = x.controls.filter(y => y.ControlId === controlId).length ?
                x.controls.filter(y => y.ControlId === controlId).filter(z => z.FriendlyName === propertyName) : [];
        } else {
            control = x.controls.filter(y => y.ControlId === controlId);
        }
        control.length ?
            control[0].Value = value
            : null
    });
    return state;
};

let removeFieldFromMetadata = (state: IControlConfigState): IControlConfigState => {
    state.fieldConfigs = [];
    return state;
};

let setAreEntityFormsLoading = (state: IControlConfigState, value: boolean): IControlConfigState => {
    state.areEntityFormsLoading = value;
    return state;
};

let setAreEntityViewsLoading = (state: IControlConfigState, value: boolean): IControlConfigState => {
    state.areEntityViewsLoading = value;
    return state;
};


export default controlConfigReducer;


// WEBPACK FOOTER //
// ./source/ts/store/reducers/control-config.ts